import { makeStyles, shorthands } from '@fluentui/react-components';
import homepageBanner from '../../image-asset/homepageBanner.png';

const getHomePageTopBannerContainerStyle = makeStyles({
  topBanner: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    ...shorthands.padding('40px'),
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap('24px'),
    alignSelf: 'stretch',
    ...shorthands.borderRadius('8px'),
    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${homepageBanner})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  texts: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('8px'),
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    textAlign: 'center',
    alignItems: 'stretch',
  },
  pageName: {
    lineHeight: '37px',
    fontSize: '28px',
    fontWeight: 600,
  },
  searchContainer: {
    marginTop: '24px',
  },
  searchBoxWrapper: {
    position: 'relative',
    height: '90px',
    ...shorthands.borderRadius('8px'),
    maxWidth: '450px',
    ...shorthands.margin('0px', 'auto'),
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  },
  searchBox: {
    width: '100%',
    height: '100%',
    ...shorthands.gap('8px'),
    ...shorthands.borderRadius('8px'),

    '&::after': {
      paddingTop: '8px',
      borderBottomRightRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
  },
  sendIcon: {
    position: 'absolute',
    bottom: '9px',
    right: '9px',
    cursor: 'pointer',
    ...shorthands.padding('0px'),
  },
});

export default getHomePageTopBannerContainerStyle;
